import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import CarWashPicOne from "../../images/car wash/car-wash-image-2.jpg";
import CarWashPicTwo from "../../images/car wash/car-wash-image-3.jpeg";
import CarWashPicFour from "../../images/car wash/car-wash-image-4 (2).jpeg";
import CarWashPicSeven from "../../images/car wash/car-wash-image-9.jpeg";
import CarWashPicSix from "../../images/car wash/car-wash-image-6.jpg";
import CarWashPicThree from "../../images/car wash/car-wash-image-1.jpg";
import CarWashPicEight from "../../images/car wash/car-wash-image-8.jpg";
import AktCarwashVideo from "./Akt-car-wash-video";
import "../../components/Section/car.css";

function OurExpertise() {
  const [showAnimation, setShowAnimation] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 2000); // 3 seconds delay

    return () => clearTimeout(timer);
  }, []);


  return (

    <div className="bg-[#0C2341]  min-h-screen mt-2">
      {showAnimation ? (
        // Spinning Circle Animation
        <div className="flex justify-center items-center min-h-[50vh]">
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 1, ease: "easeInOut" }}
            className="w-16 h-16 border-4 border-t-blue-500 border-b-transparent border-r-transparent border-l-blue-500 rounded-full"
          ></motion.div>
        </div>
      ) : (
        <main className="w-full">
          <div className="w-full overflow-hidden font-sans text-gray-800 !bg-[#ffffff]">
            <section className="relative w-full h-[70vh]">
              <img src={CarWashPicOne} alt="Hero" className="absolute inset-0 w-full h-full object-cover" />

              <div className="absolute bottom-0 left-0 right-0 flex justify-center pb-6">
                <div className="px-6 py-6 text-center rounded-md max-w-3xl mx-auto">
                  <h2
                    className="text-3xl sm:text-4xl font-bold tracking-widest mb-2"
                    style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                  >
                    OUR SERVICES
                  </h2>
                  <p className=" sm:text-xl text-gray-800 leading-relaxed text-md">
                    Experience a hassle-free clean with our advanced automatic car wash system. Fast, efficient, and designed to leave your vehicle spotless and shining.
                  </p>
                </div>
              </div>
            </section>


            {/* Description */}


            {/* Sections */}
            <div className="space-y-12">
              <div className="w-full">
                {/* <div className='text-center mt-4 mb-2 max-w-3xl mx-auto'>
                  <h2
                    className="text-2xl font-bold tracking-widest p-2 text-center text-BLACK"
                    style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                  >
                    AUTOMATIC CAR WASH PROCESS
                  </h2>
                </div> */}
                {/* Top Section - Image & Text */}
                <div className="mx-auto md:mt-3">
                  <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-stretch">
                    {/* Left Side - Text Content */}
                    <div className="lg:col-span-5 bg-blue text-[#0c2340] p-6 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[500px]">
                      <h2 className="text-2xl font-bold tracking-widest p-2 text-center"
                        style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}>
                        CAR WASH PROCESS
                      </h2>
                      <p className="text-sm md:text-lg md:mt-1 mb-6 text-justify">
                        An automatic car wash is a system that cleans vehicles without the need for manual labor. The process begins when a vehicle enters the wash bay and is positioned using sensors or guide rails. The system then sprays the car with water to loosen dirt, followed by the application of cleaning foam or soap. Rotating brushes or cloth strips scrub the vehicle’s surface while undercarriage sprayers clean the bottom. After scrubbing, the car is rinsed with high-pressure water to remove soap and grime. A wax coating may be applied for shine and protection. Finally, powerful dryers blow away remaining water, leaving the vehicle clean and dry within minutes.
                      </p>
                    </div>

                    {/* Right Side - Image */}
                    <div className="lg:col-span-7 overflow-hidden object-fill flex">
                      <div className="w-full md:h-[500px] overflow-hidden object-fill rounded-lg">
                        <AktCarwashVideo />
                      </div>
                    </div>




                  </div>
                </div>

              </div>

              {/* Section 1 */}
              <div className='text-center mt-4 max-w-3xl mx-auto'>
                <h2
                  className="text-3xl font-bold tracking-widest"
                  style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                >
                  AUTOMATIC CAR WASH SERVICES
                </h2>
              </div>
              <div className="md:flex items-center justify-center">
                <img src={CarWashPicTwo} alt="Preparation" className="md:w-1/2 w-full rounded-lg" />
                <div className="md:w-1/3 w-full p-8 bg-white shadow-lg rounded-lg">
                  <h2
                    className="text-2xl font-bold tracking-widest mb-4 text-center text-gray-800"
                    style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                  >
                    AUTOMATIC CAR WASH
                  </h2>
                  <p className="text-gray-800 text-xl leading-normal text-justify" style={{ wordSpacing: '0', hyphens: 'auto' }}>
                    Our automatic car wash delivers a fast, efficient clean using advanced touchless or soft-touch systems. High-pressure jets, wax coating, and powerful drying ensure a spotless finish with minimal effort. Save time and protect your vehicle with eco-friendly technology that reduces water and energy use-perfect for a modern, hassle free car care experience.
                  </p>
                </div>
              </div>

              {/* Section 2 */}
              <div className="md:flex md:flex-row-reverse items-center justify-center px-4 py-4">
                <img src={CarWashPicThree} alt="Non-invasive" className="md:w-1/2 w-full rounded-lg" />
                <div className="md:w-1/3 w-full p-8 bg-white shadow-lg text-center justify-center">

                  <h2
                    className="text-2xl font-bold tracking-widest p-8"
                    style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                  >
                    DESCRIPTION
                  </h2>
                  <p className="text-gray-800 text-xl leading-normal text-justify" style={{ wordSpacing: '0', hyphens: 'auto' }}>
                    combined the advantage of stale operation of the rollover car wash machine and the fine washing of the single arm touchless car wash machine and taking the full consideration of the rational usage and variety of the function, Risense developed a new model of rollover double arm touchless car wash machine so as to realize the intensification and multi-effect of car washing machine.
                  </p>
                </div>
              </div>

              {/* Section 3 */}
              <div className="md:flex items-center justify-center px-4 py-4">
                <img src={CarWashPicFour} alt="Durability" className="md:w-1/2 w-full rounded-lg" />
                <div className="md:w-1/3 w-full p-8 bg-white shadow-lg text-center justify-center">
                  <h2
                    className="text-2xl font-bold tracking-widest p-8"
                    style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                  >
                    TOUCHLESS CAR WASH MACHINE
                  </h2>
                  <p className="text-gray-800 text-xl leading-normal text-justify" style={{ wordSpacing: '0', hyphens: 'auto' }}>
                    Our full automatic car wash machine delivers a fast, efficient, and spotless clean for every vehicle. Designed with advanced sensors and soft-touch technology, it ensures thorough washing without damaging the paint. The system handles pre-soak, foam wash, scrubbing, rinsing, and drying automatically. It saves time, reduces water usage, and offers a premium cleaning experience. Ideal for high-traffic areas, it guarantees customer satisfaction with every wash.
                  </p>
                </div>
              </div>

              {/* Section 4 */}
              {/* <div className="md:flex md:flex-row-reverse items-center justify-center px-4 py-4">
              <img src={CarWashPicFive} alt="Our Prep" className="md:w-1/2 w-full rounded-lg" />
              <div className="md:w-1/3 w-full p-8 bg-white shadow-lg text-center justify-center">
                <h2
                  className="text-2xl font-bold tracking-widest p-8"
                  style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                >
                  DASHBOARD & DOOR POLISH
                </h2>
                <p className="text-lg sm:text-xl text-gray-800 leading-relaxed text-justify">
                We offer a thorough cleaning and polishing service for your car’s dashboard, gear console, and interior door panels. 
                Our experts carefully remove dust, dirt, and smudges, restoring the original look and feel of your interiors. 
                Using premium cleaning products and conditioners, we bring back the shine and freshness to every surface. 
                This treatment not only enhances the appearance but also helps protect against fading and cracking over time. 
                Give your car’s interior a revitalized, showroom-like finish with our professional care.
                </p>
              </div>
              </div> */}

              {/* Car Detailing */}
              <section className="relative w-full h-[80vh] p-4">
                <img src={CarWashPicSix} alt="Hero" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-y-0 right-0 flex items-center justify-end pr-10">
                  <div className="px-6 py-6 text-center rounded-md max-w-3xl text-white">
                    <h2
                      className="text-2xl sm:text-4xl font-bold tracking-widest mb-4"
                      style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                    >
                      SERVICE DETAILING
                    </h2>
                    <p className="text-lg sm:text-xl leading-relaxed">
                      At AKT, we offer professional car washing services to keep your vehicle looking its absolute best. Our team carefully cleans, polishes, and protects every surface, inside and out. We use premium products and techniques to restore your car’s shine and freshness. Trust AKT to bring out the true beauty of your vehicle.
                    </p>
                  </div>
                </div>
              </section>
              <div className="md:flex items-center justify-center px-4 py-4">
                <img src={CarWashPicEight} alt="Durability" className="md:w-1/2 w-full rounded-lg" />
                <div className="md:w-1/3 w-full p-8 bg-white shadow-lg text-center justify-center">
                  <h2
                    className="text-2xl font-bold tracking-widest p-8"
                    style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                  >
                    AUTOMATIC TUNNEL CAR WASH MACHINE
                  </h2>
                  <p className="text-gray-800 text-xl leading-normal text-justify" style={{ wordSpacing: '0', hyphens: 'auto' }}>
                    Automatic tunnel car wash machine offers continuous, high-speed cleaning for all types of vehicles. Equipped with multiple stages like pre-wash, foam application, scrubbing, rinsing, and drying, it ensures a deep and consistent clean. The conveyor-driven system allows cars to move smoothly through the wash process. Built for durability and efficiency, it maximizes throughput and customer satisfaction. Perfect for busy locations, it delivers a professional wash in minutes.
                  </p>
                </div>
              </div>
              <div className="md:flex md:flex-row-reverse items-center justify-center px-4 py-4">
                <img src={CarWashPicSeven} alt="Our Prep" className="md:w-1/2 w-full rounded-lg" />
                <div className="md:w-1/3 w-full p-8 bg-white shadow-lg text-center justify-center">
                  <h2
                    className="text-2xl font-bold tracking-widest p-8"
                    style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                  >
                    BENEFITS
                  </h2>
                  <ul className="text-lg sm:text-xl text-gray-800 text-left">
                    <li>- Secure, gated buildings</li>
                    <li>- Temperature controlled, dust free</li>
                    <li>- 24/7 on-site security with CCTV monitoring</li>
                    <li>- Surgically clean environment</li>
                    <li>- Kuberth easy-rise tyre cradles</li>
                    <li>- CTEK battery maintainer / charger</li>
                    <li>- Supersoft black fitted car cover</li>
                    <li>- Deep wash upon entry</li>
                    <li>- Monthly washing & starting procedure</li>
                    <li>- Out of hours access available</li>
                    <li>- Dedicated parking spaces</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <AktVideo /> */}
            {/* <div className="py-6">
            <div className="bg-white rounded-xl">
              <div className="mx-auto px-4 py-10 sm:px-10 sm:py-14">
                <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                  {powderCoatingItems.map((item) => (
                    <div
                      key={item.id}
                      className="group block overflow-hidden rounded-2xl shadow-2xl hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-gradient-to-br from-white to-gray-50 cursor-pointer"
                    >
                      <div className="relative">
                        <div className="w-full h-64 overflow-hidden">
                          <img
                            src={item.img}
                            alt={item.name}
                            className="w-full h-full object-cover transition-opacity duration-300 rounded-t-2xl"
                          />
                          {item.type === "video" && (
                            <div className="absolute inset-0 flex items-center justify-center">
                              <img
                                src={PlayButton}
                                alt="Play Button"
                                className="h-20 rounded-full bg-black/45 hover:bg-[#0c2340]"
                              />
                            </div>
                          )}
                        </div>
                        <div className="px-4 py-3 text-center">
                          <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 group-hover:text-blue-600 transition duration-300 tracking-wide">
                            {item.name}
                          </h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div> */}
          </div >
        </main>
      )}
    </div>

  );
}

export default OurExpertise;

